import { render, staticRenderFns } from "./global-snackbar.vue?vue&type=template&id=a8b9e3c8&"
import script from "./global-snackbar.vue?vue&type=script&lang=js&"
export * from "./global-snackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports